import React from 'react';
import TimeLineComponent from './TimeLineComponent';

const Cards = ({ title, count, data, type }) => {
	return (
		<div className="cards">
			<div className="cardsTitle">
				<span>{title}</span>
				{count ? <span style={{ marginLeft: '5px' }}>{count}</span> : ''}
			</div>
			{!type ? (
				<div className="cardsBody">
					{data?.map((e) => (
						<div className="subValues">
							<span className="properties" style={{textTransform:"capitalize"}}>{e.properties}</span>
							<span className="propertiesValues">₹ {e.value.toLocaleString()}</span>
						</div>
					))}
				</div>
			) : (
				<TimeLineComponent data={data} />
			)}
		</div>
	);
};

export default Cards;
